import { aggregatedClasses } from '@elliemae/ds-classnames';
import { dataGridBlockName, headerBlockName, bodyBlockName } from '../../blockNames.js';

var NoResultsContainer = aggregatedClasses('div')("".concat(dataGridBlockName, "-no-results"));
var SpinnerContainer = aggregatedClasses('div')("".concat(dataGridBlockName, "-spinner"));
var DatagridWrapper = aggregatedClasses('div')("".concat(dataGridBlockName, "-wrapper"), null, function (_ref) {
  var fluidHeight = _ref.fluidHeight;
  return {
    fluid: fluidHeight
  };
});
var TableWrapper = aggregatedClasses('div')(dataGridBlockName);
var HeaderWrapper = aggregatedClasses('div')(headerBlockName);
var HeaderRow = aggregatedClasses('div')(headerBlockName, 'row');
var HeaderCell = aggregatedClasses('div')(headerBlockName, 'cell', function (_ref2) {
  var wrapText = _ref2.wrapText;
  return {
    wrapText: wrapText
  };
});
var BodyWrapper = aggregatedClasses('div')(bodyBlockName, null, function (_ref3) {
  var grouped = _ref3.grouped;
  return {
    'ie-flex-basis-auto': true,
    'is-grouped': grouped
  };
});
var BodyRow = aggregatedClasses('div')(bodyBlockName, 'row');
var BodyCell = aggregatedClasses('div')(bodyBlockName, 'cell', function (_ref4) {
  var wrapText = _ref4.wrapText;
  return {
    wrapText: wrapText
  };
});

export { BodyCell, BodyRow, BodyWrapper, DatagridWrapper, HeaderCell, HeaderRow, HeaderWrapper, NoResultsContainer, SpinnerContainer, TableWrapper };
//# sourceMappingURL=defaultClassedRenderers.js.map
